export const EXPERIENCE = { value: "EXPERIENCE", key: "admin.guarantees.categoryTypes.experience" };
export const MUTUAL = {
  value: "MUTUAL",
  key: "admin.guarantees.categoryTypes.mutual",
};
export const OTHER = {
  value: "OTHER",
  key: "admin.guarantees.categoryTypes.other",
};

export default [EXPERIENCE, MUTUAL, OTHER];


// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/enums/guaranteeCategoryTypes.js